<template>
  <AlModal
    :open-modal="showModal"
    data-testid="navigate-away-modal"
    :config="config"
    @close-modal="cancel"
    @close="cancel"
  >
    <Localization :message="body" />
  </AlModal>
</template>

<script>
import { AlModal } from "@playvox/almendra-components";
import { Translator, Localization } from "@agyletime/wfm-vue-common";

export default {
  name: "NavigateAwayModal",
  mixins: [Translator],
  components: {
    AlModal,
    Localization,
  },
  props: {
    header: {
      type: String,
      default: "navigate-away-header",
    },
    body: {
      type: String,
      default: "navigate-away-content",
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    config() {
      return {
        header: this.translate(this.header),
        size: "sm",
        buttons: [
          {
            class: "is-secondary-red is-small",
            label: this.translate("navigate-away-cancel"),
            testId: "navigate-away-back",
            command: () => {
              this.cancel();
            },
          },
          {
            class: "is-secondary is-small",
            label: this.translate("navigate-away-continue"),
            testId: "accept",
            command: () => {
              this.continue();
            },
          },
        ],
      };
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel-modal");
    },
    continue() {
      this.$emit("continue-modal");
    },
  },
};
</script>
